import type { FaireProductEntity } from "../../entity_types/product";

export const p_sjk82qvyg7: FaireProductEntity = {
  token: "p_sjk82qvyg7",
  type: "product",
  name: "Ancient Forest Candle | Rustic | Nature Inspired | Soy Wax",
  brandToken: "b_tnzgvgustz",
  brandName: "Pacific North Wicks",
  imageUrl:
    "https://cdn.faire.com/fastly/10b578bc5047649d232a43d45bf9cf70c9e4ea1bbcf486e97e2bd31de8a24a24.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e8d555545ce1ac9fea740a9d81cde268dd3030d8c0e8f610c115affea16e3d5f.png",
    "https://cdn.faire.com/fastly/3c63bec1164e7df8b8addb8aae066bb0d8fb662131d2d945ca28775cb48a96ad.png",
    "https://cdn.faire.com/fastly/2a2cacb9c739a0c997d9642b3aa2e1e2195a2c959acda54cc223095a80fb8fe2.png",
  ],
  priceDollars: 12,
  description:
    "𝐒𝐜𝐞𝐧𝐭 𝐍𝐨𝐭𝐞𝐬:\nDeep Woods - Mycelium - Fallen Timber\n\nOur bestselling Ancient Forest Candle is an ode to the old growth forests of the Pacific Northwest. Capturing the magical essence of these deep woods in a fragrance was a tall order, and we (and our customers) are obsessed with the result!\n\nEarthy and Woodsy notes are well balanced to create a deeply nuanced fragrance that is both luxurious and rustic.\n\n𝐅𝐞𝐚𝐭𝐮𝐫𝐞𝐬:\n• 8 oz Clean Burning Soy Wax\n• Burn Time ~ 45 Hours\n• Lead-Free Cotton Core Wicks\n• Premium Phthalate-Free Fragrance Oils\n• Reusable Amber Glass Jars\n• 2.9” Wide x 3.6” Tall\n• Recyclable Shipping Materials and Packaging\n• Small Batch - Hand Poured\n\nMade with 🖤 in Gig Harbor, WA",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:48:14.212Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
